export interface SubjectiveAndObjectiveFindings{
    summarySubObjFindings:string;
}

export const defaultSubjectiveAndObjectiveFindings:SubjectiveAndObjectiveFindings = {
    summarySubObjFindings: ""
}